module.exports = __webpack_public_path__ + "img/litloyal-demo1.2c1f7d0b.png";